import { string, object } from "yup";

export function validationCodeCopyAndPasteSchema() {
    return object().shape({
        qrCode: string().typeError("Código precisa ser preenchido").required("Código: Precisa ser preenchido."),
    });
}
export const defaultValuesCodeCopyAndPaste = {
    qrCode: null
};